<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('close')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="mt-5 subscription-form-content">
          <div class="col-md-12 mb-3" *ngIf="errorMessage">
            <div class="alert alert-danger mb-0">{{ errorMessage }}</div>
          </div>
          <div class="col-md-12 mb-3">
            <label for="paymentMethod" class="payment-method">
              Select payment method:
              <ng-select
                [items]="paymentMethods"
                placeholder="Payment Method"
                [searchable]="true"
                id="paymentMethod"
                class="filter"
                [(ngModel)]="paymentMethod"
                (ngModelChange)="handlePaymentMethod($event)"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item }}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{ item }}
                </ng-template>
              </ng-select>
            </label>
          </div>
          <div class="col-md-12 mb-3" *ngIf="paymentMethod !== PaymentMethods.LINK">
            <label for="subscription">Select Subscription</label>
            <select class="form-control" id="subscription" [(ngModel)]="selectedSubscription" (ngModelChange)="handleSubscriptionChange()">
              <option *ngFor="let subscription of subscriptions" [ngValue]="subscription">
                {{ subscription.name }}
              </option>
            </select>
          </div>
          <div class="col-md-12 mb-3" *ngIf="paymentMethod !== PaymentMethods.LINK && isCampSubscription()">
            <label for="campPeriods" class="payment-method">
              Choose camp periods:
              <ng-select
                [items]="getCampPeriods()"
                bindLabel="periodStartDate"
                bindValue="bundleId"
                [searchable]="false"
                id="campPeriods"
                class="filter"
                [(ngModel)]="selectedCampBundleId"
                placeholder="Select camp period"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item.periodStartDate }} - {{ item.periodEndDate }}
                </ng-template>
              </ng-select>
            </label>
          </div>
          <div class="col-md-12 mb-3" *ngIf="isChildRequired()">
            <label for="child" class="payment-method">
              Assign child:
              <ng-select
                [items]="user.children"
                bindLabel="firstname"
                bindValue="id"
                [searchable]="true"
                [clearable]="false"
                id="child"
                class="filter"
                [(ngModel)]="selectedChildId"
                placeholder="Select child"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item.firstname }} {{ item.lastname }}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{ item.firstname }} {{ item.lastname }}
                </ng-template>
              </ng-select>
            </label>
            <span class="text-muted" *ngIf="!user.children?.length">No children found. Add child in the Children section.</span>
          </div>
          <ng-container *ngIf="paymentMethod === PaymentMethods.LINK">
            <div class="col-md-12 mb-3">
              <label for="amount">Payment Amount</label>
              <input
                type="number"
                class="form-control"
                id="amount"
                [(ngModel)]="amount"
                min="0"
                step="0.01"
                placeholder="Enter amount"
              />
            </div>
            <div class="col-md-12 mb-3 form-check" style="margin-left: 1.25rem">
              <label class="form-check-label" for="withVat">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="withVat"
                  [(ngModel)]="taxRequired"
                />
                With VAT
              </label>
            </div>
          </ng-container>
          <div class="col-md-12" *ngIf="shouldShowStartDate()">
            <label for="datepicker">Select Start Date</label>
            <input
              class="form-control"
              id="datepicker"
              name="datepicker"
              ngbDatepicker
              #datepicker="ngbDatepicker"
              [(ngModel)]="dateStart"
              (click)="datepicker.toggle()"
              placeholder="dd.mm.yyyy"
            />
          </div>
          <div class="modal-buttons text-center mb-5">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal()">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('close')">Cancel</button>
          </div>
        </div>
    </div>
  </div>
</div>
